export class GetInternalDocumentByIdRequest {
    public key: string = "getInternalDocumentById"
    constructor(public payload: string = "") {}
}
